import React from 'react';
import './CourseShowcase.css';

function CourseShowcase() {
    return (
        <div className="course-showcase-container">
            <h1 className="course-showcase-title">
                Course Showcase & Success Stories
            </h1>

            <p className="course-showcase-intro">
                See what our learners have achieved and explore examples of our engaging workshops.
            </p>

            <div className="course-showcase-image-scroll">
                <img
                    src="https://source.unsplash.com/random/600x400/?adult,learning,classroom"
                    alt="Workshop in action"
                    className="course-showcase-image"
                />
                <img
                    src="https://source.unsplash.com/random/600x400/?students,studying,group"
                    alt="Learner collaboration"
                    className="course-showcase-image"
                />
                <img
                    src="https://source.unsplash.com/random/600x400/?graduation,adult,education"
                    alt="Successful graduate"
                    className="course-showcase-image"
                />
                <img
                    src="https://source.unsplash.com/random/600x400/?online,course,laptop"
                    alt="Online learning setup"
                    className="course-showcase-image"
                />
            </div>

            <p className="course-showcase-summary">
                Our courses are designed to be practical, engaging, and immediately applicable.
                We focus on building real-world skills and fostering a love for lifelong learning.
                Many of our participants have gone on to achieve new career heights, start
                businesses, or simply gain more confidence in their daily lives.
            </p>
        </div>
    );
}

export default CourseShowcase;
